import React from 'react';
import useStyle from './lastChallengeResult.style';
import { PedagogicalChallengesWinnersBlock } from 'components/molecules/Blocks/PedagogicalChallengesWinnersBlock';
import { LastDefi } from 'graphql/generated/graphql';

interface LastChallengeResultProps {
  defi: LastDefi;
}

export const LastChallengeResult = ({ defi }: LastChallengeResultProps) => {
  const classes = useStyle();

  return (
    <>
      <div className={classes.topBar}>
        <p>{defi.name}</p>
      </div>
      <h4 className={classes.title}>Liste des gagnants</h4>
      <PedagogicalChallengesWinnersBlock awardsList={defi.recompenses} />
    </>
  );
};
